<template lang="pug">
  b-container
    p ※desknet's NEOクラウド版、ChatLuckクラウド版の両方をご契約
    p.ml-3 いただいている場合は、どちらか一方の
      a.sub-domain.text-left(@click="displayControlSubDomainExplanation()") サブドメイン
      | をご入力ください。
      div.domain-image(v-show="subDomainDisplay")
        img.image-width(src="@/assets/images/sub_domain.png")
        p.text-left ※URLはサンプルです。
        p.text-left.ml-3 お客様の環境に合わせてご入力ください。
</template>

<script>

export default {
  name: "SubDomainToolTips",
  data() {
    return {
      // サブドメインの説明の表示フラグ
      subDomainDisplay: false,
    }
  },
  methods: {
    // サブドメインの説明を表示制御する
    displayControlSubDomainExplanation: function() {
      // サブドメインの説明の表示を制御する
      document.addEventListener('click', (e) => {
        // サブドメインのリンク・説明をクリックした場合、サブドメインの説明を開く
        this.subDomainDisplay = e.target.closest('.sub-domain') !== null || e.target.closest('.domain-image') !== null;
      });
    }
  },
}
</script>

<style scoped>
.image-width {
  max-width: 486px;
}
.domain-image {
  position: absolute;
  background-color: white;
  color: black;
  border: solid 2px;
  z-index: 1;
  margin-top: 10px;
}
.domain-image:after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  border: 15px solid transparent;
  border-bottom: 15px solid #000;
  margin-bottom: 2px;
  margin-left: 40px;
}
.sub-domain {
  cursor: pointer;
}
</style>